import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MerchApp.css';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const MerchApp = () => {
    const navigate = useNavigate();

    // Add useEffect for scroll prevention
    useEffect(() => {
        // More comprehensive scroll prevention
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.touchAction = 'none'; // Prevent touch scrolling

        return () => {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = 'unset';
            document.body.style.position = 'static';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
            document.body.style.touchAction = 'auto';
        };
    }, []);

    const handleBulkImport = () => {
        navigate('/merch/bulk-import');
    }

    const handleManualAdd = () => {
        navigate('/merch/manual-add');
    }

    return (
        <div className="merch-login-container">
            <div className="merch-mobile-frame">
                {/* Home button positioned at top right for mobile */}
                <div className="merch-home-button-container">
                    <span onClick={() => navigate('/')}
                        className='merch-home-button'>HOME</span>
                </div>
                <div className="login-content">
                    <div className="login-image-wrapper">
                        <div className="image-container">
                            {/* Removed image display - now just black background */}
                        </div>
                        <div className="login-branding">
                            <p className="uppercase tracking-[3px] font-medium">M E R C H</p>
                        </div>
                    </div>
                    <div className="login-buttons !bottom-[20px]">
                        <button
                            className="login-button reduced-height opacity-50 cursor-not-allowed"
                            disabled
                        >
                            Bulk Import
                            <span className="text-[10px] text-[rgba(153,50,204,0.7)] block mt-1">Coming Soon</span>
                        </button>
                        <button
                            className="login-button reduced-height opacity-50 cursor-not-allowed"
                            disabled
                        >
                            Manual Add
                            <span className="text-[10px] text-[rgba(153,50,204,0.7)] block mt-1">Coming Soon</span>
                        </button>
                        <button
                            className="login-button reduced-height"
                            onClick={() => navigate('/merch/view-all')}
                        >
                            View all
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MerchApp; 